import React from 'react';
import { Mail, Phone, Navigation } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { ActivityMap, directionsUrl } from '@/components/ActivityMap';

// Public activity block: booking contacts, map and directions (no outbound links besides navigation).
export const ActivityInfo = ({ restaurant, t }) => {
  const { booking_email, contacts, location } = restaurant;
  if (!booking_email && !contacts && !location) return null;
  return (
    <div className="mt-4 space-y-3" data-testid="activity-info">
      {(booking_email || contacts) && (
        <div className="space-y-1.5">
          <p className="text-xs font-semibold uppercase tracking-[0.15em] text-muted-foreground font-sans">{t('act_book_label')}</p>
          {contacts && <div className="flex items-start gap-2 text-sm font-sans" data-testid="detail-contacts"><Phone className="w-4 h-4 mt-0.5 text-muted-foreground shrink-0" strokeWidth={1.5} /><span className="whitespace-pre-line select-all">{contacts}</span></div>}
          {booking_email && <div className="flex items-center gap-2 text-sm font-sans" data-testid="detail-booking-email"><Mail className="w-4 h-4 text-muted-foreground shrink-0" strokeWidth={1.5} /><span className="select-all break-all">{booking_email}</span></div>}
        </div>
      )}
      {location && (
        <>
          <ActivityMap location={location} testid="detail-map" />
          <Button variant="outline" className="w-full rounded-full btn-lift" onClick={() => window.open(directionsUrl(location), '_blank', 'noopener')} data-testid="detail-directions-btn">
            <Navigation className="w-4 h-4 mr-2" strokeWidth={1.5} /> {t('act_directions')}
          </Button>
        </>
      )}
    </div>
  );
};
